import React from "react";
import { useState } from "react";
import {
  H6,
  H5,
  P,
  Btn,
} from "AbstractElements";
import {
  Col,
  Card,
  CardHeader,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Collapse,
} from "reactstrap";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { ChevronDown } from "react-feather";
import { fetchGuidelineDetail } from "Features/Learning/Guidelines/Utils/GuidelineUtils";
import { handleDeleteGuideline, handleEditGuideline } from "./GuidelineUtil";
import { setFieldGuideline } from "Features/Learning/Guidelines/addGuidelineSlice";

const MembershipList = ({
  membershipId,
  detail,
  dispatch,
  setRefatch
}) => {
  const guidelineData = useSelector(state => state.Guideline.data.data);
  const [isOpen, setIsOpen] = useState(false);
  const [dataMateri, setDataMateri] = useState([])
  const [day, setDay] = useState('');

  const handleOpen = (id) => {
    setDay(id);
    dispatch(fetchGuidelineDetail({ membershipId, guidelineDay: id })).then((response) => {
      setDataMateri(response?.payload?.data)
      setIsOpen(true)
    }).catch((error) => {
      console.error('Error fetching guideline detail:', error);
    });
  };

  const handleClose = () => {
    setDataMateri([])
    setIsOpen(false)
  }

  const [isActivity, setIsActivity] = useState([]);

  const handleChange = (e) => {
    let collapseCopy = [...isActivity];
    collapseCopy[e] = !collapseCopy[e];
    setIsActivity(collapseCopy);
  };

  const cardHeader = (item) => {
    return (
      <CardHeader style={{ marginRight: "15px", padding: "2px" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <div
              style={{
                marginLeft: "10px",
                display: "flex",
                alignItems: "center",
              }}
            >
              {(item?.items?.length > 0) ? (
                <>
                  <H6 attrH6={{ className: "m-0" }}>{item?.id}</H6> &nbsp; - &nbsp;
                  <H6 attrH6={{ className: "m-0" }}>{item?.title_group}</H6>
                </>
              ) : (
                <a href={item?.link} target="_blank" rel="noopener noreferrer">- {item?.title}</a>
              )}
            </div>
          </div>
          <div style={{ display: "flex", alignItems: "center" }}>
            {(item?.items?.length > 0) && (
              <>
                <Btn
                  attrBtn={{
                    color: "ps-0",
                    onClick: () => handleChange(item.id),
                    datatoggle: "collapse",
                    datatarget: `#collapseicon${item.id}`,
                    ariaexpanded: "true",
                    ariacontrols: `collapseicon${item.id}`,
                    style: {
                      textAlign: "center",
                      alignItems: "center",
                      justifyContent: "center",
                      display: "flex",
                    },
                  }}>
                  <ChevronDown />
                </Btn>
                <Link
                  to={`${process.env.PUBLIC_URL}/membership/guideline-add/${membershipId}`}
                  onClick={() => handleEditGuideline(dispatch, { ...item, day, membershipId }, setFieldGuideline)}
                >
                  <Btn
                    attrBtn={{
                      color: "link",
                      outline: true,
                      className: "p-1",
                    }}
                  >
                    <i className="fa fa-pencil mx-auto"></i>
                  </Btn>
                </Link>
                <Btn
                  attrBtn={{
                    color: "link",
                    outline: true,
                    className: "p-1",
                    onClick: () => {
                      handleDeleteGuideline(dispatch, item.id, setRefatch)
                      handleClose();
                    },
                  }}>
                  <i className="fa fa-trash-o mx-auto text-danger"></i>
                </Btn>
              </>
            )}
          </div>
        </div>
      </CardHeader>
    );
  };

  return (
    <>
      <Col sm={"12 order-2"}>
        <Card>
          <CardHeader>
            <H5>
              List Guideline membership {detail?.title}
            </H5>
          </CardHeader>
          <div>
            <Table className="table-responsive">
              <thead className="table-light">
                <tr>
                  <th scope="col">{"#"}</th>
                  <th scope="col">Day</th>
                  <th scope="col" className="text-center">{"Aksi"}</th>
                </tr>
              </thead>
              <tbody>
                {guidelineData?.days &&
                  guidelineData?.days.map((item, index) => (
                    <tr key={`item-${index}`} id={item.id}>
                      <th>{index + 1}</th>
                      <td>{item}</td>
                      <td className="text-center d-flex gap-2 justify-content-center align-items-center">
                        <Btn
                          attrBtn={{
                            color: "link",
                            outline: true,
                            className: "p-1",
                            onClick: () => handleOpen(item)
                          }}>
                          <i className="fa fa-info-circle mx-auto fa-lg"></i>
                        </Btn>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </div>
        </Card>
      </Col>
      <Modal isOpen={isOpen} toggle={handleClose} backdrop="static">
        <ModalHeader toggle={handleClose}>Materi</ModalHeader>
        <ModalBody>
          {
            dataMateri.length > 0 ? (
              dataMateri.map((item, index) => (
                <Card key={`materi-${index}`} className="mb-2">
                  {cardHeader(item)}
                  <Collapse isOpen={isActivity[item?.id]}>
                    {item?.items?.map((child, index) => {
                      return (
                        <React.Fragment key={index}>
                          {cardHeader(child)}
                        </React.Fragment>
                      );
                    })}
                  </Collapse>
                </Card>
              ))
            ) : (
              <P>Tidak ada materi tersedia.</P>
            )
          }
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={handleClose}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default MembershipList;